// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"cd01fbf7b5--collapsed--ZnFZc","expandable":"cd01fbf7b5--expandable--nDfVT","button":"cd01fbf7b5--button--DxRHT","inline-text":"cd01fbf7b5--inline-text--Ty1iC"};